export default __webpack_public_path__ + "static/earning-insight-14daef083e568e7e15553bb4e56b7482.mp4";